"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Lens = _interopRequireDefault(require("@material-ui/icons/Lens"));
var _hover = require("../../hooks/hover");
var _Highlight = _interopRequireDefault(require("../Highlight"));
var _excluded = ["avatar", "fromName", "fromAddress", "title", "snippet", "receivedAt", "actions", "onClick", "readStatus", "selected", "showDot", "checkbox", "showCheckbox", "labels", "attachments", "messageCount", "className", "_className", "highlightWord"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ThreadListItem = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var avatar = _ref.avatar,
    fromName = _ref.fromName,
    fromAddress = _ref.fromAddress,
    title = _ref.title,
    snippet = _ref.snippet,
    receivedAt = _ref.receivedAt,
    actions = _ref.actions,
    onClick = _ref.onClick,
    _ref$readStatus = _ref.readStatus,
    readStatus = _ref$readStatus === void 0 ? false : _ref$readStatus,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    _ref$showDot = _ref.showDot,
    showDot = _ref$showDot === void 0 ? true : _ref$showDot,
    checkbox = _ref.checkbox,
    showCheckbox = _ref.showCheckbox,
    labels = _ref.labels,
    attachments = _ref.attachments,
    _ref$messageCount = _ref.messageCount,
    messageCount = _ref$messageCount === void 0 ? 0 : _ref$messageCount,
    className = _ref.className,
    _className = _ref._className,
    _ref$highlightWord = _ref.highlightWord,
    highlightWord = _ref$highlightWord === void 0 ? '' : _ref$highlightWord,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useHover = (0, _hover.useHover)(),
    hovered = _useHover.hovered,
    targetProps = _useHover.targetProps;
  var hasAttachment = !(0, _isNil["default"])(attachments);
  var textColor = readStatus ? 'text-light' : 'text-dark';
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, targetProps, {
    ref: ref,
    style: props.style,
    className: (0, _classnames["default"])('w-full thread-list-item bg-app cursor-pointer hover:z-10 hover:shadow-hover dark:hover:shadow-deep py-5', {
      'bg-secondary': selected
    }, className, _className)
  }), /*#__PURE__*/_react["default"].createElement(Layout, {
    onClick: onClick,
    checkbox: /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])({
        invisible: !showCheckbox && !hovered
      })
    }, checkbox),
    avatar: avatar,
    actions: hovered && actions ? actions : /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])('text-sm font-bold leading-loose', textColor)
    }, receivedAt)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col w-full min-w-0 select-none"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-baseline w-full mb-1"
  }, !readStatus && showDot && /*#__PURE__*/_react["default"].createElement(ReadDot, {
    className: "mr-1 text-primary"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "truncate"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('font-bold text-lg mr-2', textColor)
  }, /*#__PURE__*/_react["default"].createElement(_Highlight["default"], {
    className: "inline-block",
    keyword: highlightWord,
    highlightClassName: "text-primary"
  }, fromName), messageCount > 1 && /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-base mx-1"
  }, "(", messageCount, ")")), fromAddress && /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('font-light text-sm mr-3', textColor)
  }, /*#__PURE__*/_react["default"].createElement(_Highlight["default"], {
    className: "inline-block",
    keyword: highlightWord,
    highlightClassName: "text-primary"
  }, fromAddress))), /*#__PURE__*/_react["default"].createElement("span", {
    className: "truncate flex-1"
  }, labels)), /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _classnames["default"])('font-light truncate text-sm max-w-full mb-3', textColor)
  }, /*#__PURE__*/_react["default"].createElement("strong", {
    className: (0, _classnames["default"])('mr-2 font-bold', textColor)
  }, title), /*#__PURE__*/_react["default"].createElement(_Highlight["default"], {
    className: "inline",
    keyword: highlightWord,
    highlightClassName: "text-primary font-bold"
  }, snippet || '')))), hasAttachment && /*#__PURE__*/_react["default"].createElement(Layout, null, attachments));
});
function Layout(_ref2) {
  var checkbox = _ref2.checkbox,
    avatar = _ref2.avatar,
    children = _ref2.children,
    actions = _ref2.actions,
    onClick = _ref2.onClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center flex-1 min-w-0"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-1 w-12"
  }, checkbox), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center w-12 h-12 ml-1 mr-5"
  }, avatar), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex flex-1 justify-between pr-3 min-w-0'),
    onClick: onClick
  }, children), actions && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex self-stretch mr-6"
  }, actions));
}
function ReadDot(props) {
  return /*#__PURE__*/_react["default"].createElement(_Lens["default"], (0, _extends2["default"])({
    style: {
      fontSize: 12
    }
  }, props));
}
var _default = exports["default"] = ThreadListItem;
//# sourceMappingURL=index.js.map